import request from "./httpService";

const NOTIFICATION_ENDPOINT = '/notification';

const sendTextNotification = (data) => {
    return request({
        method: "POST",
        url: `${NOTIFICATION_ENDPOINT}/text`,
        data: data,
    });
};

export const NotificationService = {
    sendTextNotification,
};